import { DataSourceTypeLabelDto } from "../../../dtos/localizationmodule/DataSourceTypeLabelDto";

class GetDataSourceTypesLabelsResult {
    Labels: DataSourceTypeLabelDto[];

    constructor(labels: DataSourceTypeLabelDto[]) {
        this.Labels = labels;
    }
}

export default GetDataSourceTypesLabelsResult;
